module.exports = __webpack_public_path__ + "img/official_seal.5de24a8f.png";